/* ===== Cenzio — mobil, ikinci katman (betik) =====
   1. Gorseller yuklenince yumusak belirir (cz-mobile-2.css .is-loaded).
   2. Bundle sepet kartinda uc parcali ilerleme cizgisi.
   Her iki is de kucuk; her sayfada calisir, telefonda gorunur.
   ==================================================================== */
(function () {
  'use strict';

  /* ---------- 1. GORSEL BELIRME ----------
     Kart ve galeri gorselleri bos kutudan birden beliriyordu. Yuklenen
     gorsele .is-loaded verilir, CSS 300 ms'de acar. Yuklenmis olanlar
     (onbellek) hemen isaretlenir ki hic gecikme olmasin. */
  var SEL = '.card__media img, .cz-tcard__media img, .cz-pcard img, .cz-story__photo img,' +
            ' .cz-arch__media img, .thumbnail img, .product__media img, .cz-rv__thumb img,' +
            ' .czj-card__media img, .czj-feature__media img, .cz-bd__media img, .cz-mnav__thumb img';

  function mark(img) {
    if (img.__czL) return;
    img.__czL = true;
    img.classList.add('cz-fade');
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
      return;
    }
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
  }
  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(mark);
  }

  /* ---------- 2. BUNDLE ILERLEME CIZGISI ----------
     "Choose 2 prints to unlock 25% off" sadece metindi. Kademelerin ustune
     uc parcali ince bir cizgi: sepetteki parca sayisi kadar parca dolar. */
  function progress() {
    var bar = document.querySelector('.cz-bundle__cart .cz-offer-bar');
    var list = document.querySelector('.cz-bundle__list');
    if (!bar || !list || bar.querySelector('.cz-prog')) return;
    var p = document.createElement('div');
    p.className = 'cz-prog';
    p.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 3; i++) p.appendChild(document.createElement('i'));
    var tiers = bar.querySelector('.cz-offer-bar__tiers');
    if (tiers) bar.insertBefore(p, tiers); else bar.appendChild(p);

    function render() {
      var n = list.querySelectorAll('.cz-bundle__row').length;
      var segs = p.children;
      for (var k = 0; k < segs.length; k++) segs[k].classList.toggle('is-on', k < n);
      p.classList.toggle('is-full', n >= 3);
    }
    render();
    if ('MutationObserver' in window) {
      new MutationObserver(render).observe(list, { childList: true, subtree: true });
    }
  }

  /* ---------- 3. HERO GECIS YONU ----------
     Telefonda yeni fotograf perde gibi acilir (cz-mobile-2.css, blok 20).
     Perdenin yonu kaydirma yonuyle ayni olsun: ileri gidince sagdan,
     geri gidince soldan. Ilk yuklemede perde yok (data-live sonradan). */
  function heroDir() {
    var H = window.customElements && customElements.get('cz-hero');
    if (!H || H.prototype.__czDir) return;
    H.prototype.__czDir = true;
    var go = H.prototype.go;
    H.prototype.go = function (n) {
      if (typeof this.i === 'number' && n !== this.i) {
        this.dataset.dir = n < this.i ? 'back' : 'next';
        this.dataset.live = '';
      }
      return go.call(this, n);
    };
  }

  /* ---------- 4. HERO ESER ISARETLERI (telefon) ----------
     Isaretler slayta gore yuzdeyle duruyor; telefonda fotograf akista
     oldugu icin fotografin icine tasinir (cz-mobile-2.css, blok 21).
     Masaustune donulurse yerine konur. */
  var heroMq = window.matchMedia('(max-width: 749px)');
  function heroSpots() {
    document.querySelectorAll('.cz-hero__slide').forEach(function (slide) {
      var art = slide.querySelector('.cz-hero__art');
      if (!art) return;
      if (heroMq.matches) {
        slide.querySelectorAll(':scope > .cz-hero__spot').forEach(function (sp) { art.appendChild(sp); });
        /* Tek isaretli slayt: ad etiketi fotografin sag alt kosesine, ayri serit */
        var spots = art.querySelectorAll('.cz-hero__spot');
        if (spots.length === 1 && !art.querySelector('.cz-hero__cap')) {
          var tag = spots[0].querySelector('.cz-hero__spot-tag');
          if (tag) {
            var cap = document.createElement('a');
            cap.className = 'cz-hero__cap';
            cap.href = spots[0].getAttribute('href');
            cap.setAttribute('aria-label', spots[0].getAttribute('aria-label') || '');
            cap.innerHTML = tag.innerHTML;
            art.appendChild(cap);
          }
        }
      } else {
        art.querySelectorAll('.cz-hero__spot').forEach(function (sp) { slide.insertBefore(sp, slide.querySelector('.cz-hero__copy')); });
        art.querySelectorAll('.cz-hero__cap').forEach(function (c) { c.remove(); });
      }
    });
  }
  if (heroMq.addEventListener) heroMq.addEventListener('change', heroSpots);

  function init() {
    scan();
    progress();
    heroDir();
    heroSpots();
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { scan(); progress(); }, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
